<form [formGroup]="siddhaYogaRetreatForm">
  <div class="step-container">
    <ng-template #labelRetreat>{{ getTranslation('pthContemplation.title') }}</ng-template>
    <div class="step-title">
      {{ isEditable ? getTranslation('pthContemplation.title') : getTranslation('pthContemplation.blockedForEdit') }}
      <span *ngIf="!isEditable" class="badge badge-warning ml-2" style="font-size: 0.75rem;">(Read Only)</span>
    </div>

    <!-- Main Selection Cards -->
    <div class="selection-container">
      <div class="selection-header">
        <h4 class="selection-title">{{ getTranslation('pthContemplation.chooseSubmissionTitle') }}</h4>
        <p class="selection-subtitle">{{ getTranslation('pthContemplation.chooseSubmissionSubtitle') }}</p>
      </div>

      <div class="submission-choice-container">
        <div class="submission-card" [class.active]="siddhaYogaRetreatForm.get('SubmissionMode')?.value === 'form'"
          (click)="siddhaYogaRetreatForm.get('SubmissionMode')?.setValue('form')">
          <div class="card-icon">
            <i class="fas fa-pencil-alt"></i>
          </div>
          <div class="card-content">
            <h5 class="card-title">{{ getTranslation('pthContemplation.card.form.title') }}</h5>
            <p class="card-description">{{ getTranslation('pthContemplation.card.form.description') }}</p>
          </div>
          <div class="card-indicator">
            <i class="fas fa-check-circle" *ngIf="siddhaYogaRetreatForm.get('SubmissionMode')?.value === 'form'"></i>
          </div>
        </div>

        <div class="submission-card" [class.active]="siddhaYogaRetreatForm.get('SubmissionMode')?.value === 'file'"
          (click)="siddhaYogaRetreatForm.get('SubmissionMode')?.setValue('file')">
          <div class="card-icon">
            <i class="fas fa-file-upload"></i>
          </div>
          <div class="card-content">
            <h5 class="card-title">{{ getTranslation('pthContemplation.card.file.title') }}</h5>
            <p class="card-description">{{ getTranslation('pthContemplation.card.file.description') }}</p>
          </div>
          <div class="card-indicator">
            <i class="fas fa-check-circle" *ngIf="siddhaYogaRetreatForm.get('SubmissionMode')?.value === 'file'"></i>
          </div>
        </div>
      </div>
    </div>




    <ng-container *ngIf="siddhaYogaRetreatForm.get('SubmissionMode')?.value === 'form'">

      <div class="form-wrapper">
      
      <!-- ================= Q1 ================= -->
      <div class="form-section mb-4 shadow-sm">
      
        <div class="section-header">
          <div class="q-badge">1</div>
          <div class="section-title">
            1. How are you studying and practising the following in your life?
          </div>
        </div>
      
        <!-- A -->
        <label class="sub-label">A. Siddha Yoga Teachings and Practices</label>
        <div class="hint">
          Mention specific teachings, practices, frequency, duration, etc.
        </div>
      
        <textarea class="form-control custom-textarea mb-1"
          formControlName="TeachingsPracticeInDetails"
          rows="4"
          maxlength="5000"
          #t1
          (input)="updateLetterCount('TeachingsPracticeInDetails', t1.value)">
        </textarea>
      
        <div class="d-flex justify-content-end mb-3">
          <span  class="counter">
            {{ getCharacterCount('TeachingsPracticeInDetails') }} / 5000
          </span>
          <span class="error-text"
            *ngIf="submitted && siddhaYogaRetreatForm.get('TeachingsPracticeInDetails')?.invalid">
            {{ getTranslation('validation.requiredField') }}
          </span>
        </div>
      
        <hr>
      
        <!-- B -->
        <label class="sub-label">B. Siddha Yoga Path Website</label>
        <div class="hint">
         [Mention specific elements (Chanting, Shree Gurumayi's talks, Commentaries, Photo galleries, etc.), how you engage with them, how frequently, etc.]:
        </div>
      
        <textarea class="form-control custom-textarea"
          formControlName="WebsitePracticeInDetails"
          rows="4"
          maxlength="5000"
          #t2
          (input)="updateLetterCount('WebsitePracticeInDetails', t2.value)">
        </textarea>
      
        <div class="d-flex justify-content-end mt-1">
          <span class="counter">
            {{ getCharacterCount('WebsitePracticeInDetails') }} / 5000
          </span>
        </div>
      
      </div>
      
      <!-- ================= Q2 ================= -->
      <div class="form-section mb-4 shadow-sm">
      
        <div class="section-header">
          <div class="q-badge">2</div>
          <div class="section-title">
           2. Describe with examples two specific benefits you have experienced from your engagement with the Siddha Yoga teachings and practices
          </div>
        </div>
      
        <label class="sub-label">A.</label>
        <textarea class="form-control custom-textarea mb-2"
          formControlName="PracticeBenefits1"
          rows="3"
          maxlength="5000"
          #b1
          (input)="updateLetterCount('PracticeBenefits1', b1.value)">
        </textarea>
        <div  class="d-flex justify-content-end mt-1">
          <span class="counter">
          {{ getCharacterCount('PracticeBenefits1') }} / 5000
          </span>
        </div>
      
        <label class="sub-label">B.</label>
        <textarea class="form-control custom-textarea mb-2"
          formControlName="PracticeBenefits2"
          rows="3"
          maxlength="5000"
          #b2
          (input)="updateLetterCount('PracticeBenefits2', b2.value)">
        </textarea>
        <div  class="d-flex justify-content-end mt-1">
          <span class="counter">
          {{ getCharacterCount('PracticeBenefits2') }} / 5000
          </span>
        </div>
      
      </div>
      
      <!-- ================= Q3 ================= -->
      <div class="form-section mb-4 shadow-sm">
        <div class="section-header">
          <div class="q-badge">3</div>
          <div class="section-title">
           3. Describe your current Siddha Yoga meditation practice.
I.e. frequency, time of day, duration; focus during meditation (mantra japa, breath, 
Shri Guru’s teachings, etc.); journaling of experiences and insights, etc.

          </div>
        </div>
      
        <textarea class="form-control custom-textarea"
          formControlName="MeditationPracticesDetails"
          rows="3"
          maxlength="5000"
          #m1
          (input)="updateLetterCount('MeditationPracticesDetails', m1.value)">
        </textarea>
      
        <div  class="d-flex justify-content-end mt-1">
          <span class="counter">
          {{ getCharacterCount('MeditationPracticesDetails') }} / 5000
          </span>
        </div>
      </div>
      
      <!-- ================= Q4 ================= -->
      <div class="form-section mb-4 shadow-sm">
        <div class="section-header">
          <div class="q-badge">4</div>
          <div class="section-title">
           4. In what ways has your practice of meditation impacted you and your experience of life?
          </div>
        </div>
      
        <textarea class="form-control custom-textarea"
          formControlName="MeditationPracticesImpact"
          rows="3"
          maxlength="5000"
          #m2
          (input)="updateLetterCount('MeditationPracticesImpact', m2.value)">
        </textarea>
      
        <div  class="d-flex justify-content-end mt-1">
          <span class="counter">

      
          {{ getCharacterCount('MeditationPracticesImpact') }} / 5000
          </span>
        </div>
      </div>
      
      <!-- ================= Q5 ================= -->
      <div class="form-section mb-4 shadow-sm">
        <div class="section-header">
          <div class="q-badge">5</div>
          <div class="section-title">
            5. State your purpose for participating in the Pilgrimage to the Heart retreat. 
How will you prepare yourself so that you are able to achieve this purpose?
          </div>
        </div>
      
        <textarea class="form-control custom-textarea"
          formControlName="Purpose"
          rows="3"
          maxlength="5000"
          #p
          (input)="updateLetterCount('Purpose', p.value)">
        </textarea>
      
        <div   class="d-flex justify-content-end mt-1" >
          <span class="counter">
          {{ getCharacterCount('Purpose') }} / 5000
          </span>
        </div>
      </div>
      
      </div>
      </ng-container>
      


    <ng-container *ngIf="siddhaYogaRetreatForm.get('SubmissionMode')?.value === 'file'">
      <!-- Generic Document Upload Component -->
      <div class="row gx-2 mt-4">
        <div class="form-group col-12 mb-3">
          <app-addendum-document-upload [config]="documentUploadConfig" [showValidationError]="documentSectionSubmitted"
            [isPreviewMode]="isPreviewMode" (documentsChange)="onDocumentsChange($event)"
            (validationChange)="onValidationChange($event)">
          </app-addendum-document-upload>
        </div>
      </div>
    </ng-container>



    <div class="btn-group vendortitle nb-progress-bar margincss mobile-responsive" *ngIf="!isPreviewMode && isEditable">
      <button type="button" class="btn savedraftbtn" (click)="onSubmit(SaveMode.DRAFT)">
        <i class="fas fa-save mr-2"></i>{{ getTranslation('button.saveAsDraft') }}
      </button>
      <button type="button" class="btn prevbtn" (click)="goToBack()">
        <i class="fas fa-arrow-left mr-2"></i>{{ getTranslation('button.previous') }}
      </button>
      <button type="button" class="btn nextbtn" (click)="onSubmit(SaveMode.SAVE)">
        <i class="fas fa-arrow-right mr-2"></i>{{ getTranslation('button.next') }}
      </button>
    </div>